interface Props {
  kind?: "deal" | "referral";
  partner?: string;
  title?: string;
  subtitle?: string;
  onClick?: () => void;
}

export function PromoCard({
  kind = "deal",
  partner,
  title,
  subtitle,
  onClick,
}: Props) {
  if (kind === "referral") {
    return (
      <button
        type="button"
        onClick={onClick}
        className="result-card cursor-pointer relative overflow-hidden bg-slate-900 text-white text-left"
        aria-label={title || "Referral offer"}
      >
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <div className="font-display font-bold text-xl">
              {title || "Give $20, Get $20"}
            </div>
            <div className="text-sm text-slate-300 mt-1">
              {subtitle || "Don't let your friends miss out on great rates."}
            </div>
            <span className="mt-3 inline-block btn-cta bg-white text-slate-900 text-sm">
              Tap to start saving
            </span>
          </div>
          <div className="hidden sm:block w-32 h-24 rounded-lg bg-gradient-to-br from-amber-400 to-rose-500 opacity-80" />
        </div>
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      className="result-card cursor-pointer text-left"
      style={{ background: "#1d4ed8", color: "#fff", borderColor: "#1d4ed8" }}
      aria-label={title || partner || "Partner promotion"}
    >
      <div className="flex items-center gap-4">
        <div className="brand-chip" style={{ background: "#0071CE" }}>
          {(partner || "Walmart")[0]}
        </div>
        <div className="flex-1">
          <div className="font-display font-bold text-lg text-white">
            {partner || "Walmart"}
          </div>
          <div className="text-sm text-white/90">
            {title || "Limited time deals"}
          </div>
          <div className="text-sm text-white/80 mt-1">
            {subtitle ||
              "Better rates when you send or receive at Walmart this month"}
          </div>
        </div>
        <div className="text-white/70 self-center shrink-0 text-2xl">›</div>
      </div>
    </button>
  );
}
